import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
const StylablePlatformIcons = ({ className, platformIcons, ...componentProps }) => {
    if (!platformIcons || !platformIcons?.length) {
        return null;
    }
    return (React.createElement("div", { className: className, "data-testid": "platform-icons", ...componentProps }, platformIcons.map((platformIcon) => (React.createElement("img", { src: platformIcon?.url, key: platformIcon?.accessibilityText, alt: platformIcon?.accessibilityText })))));
};
export const PlatformIcons = styled(StylablePlatformIcons) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=PlatformIcons.js.map